import React, { Component } from 'react';
import './ec2PaTitle.css';
import {API} from 'aws-amplify';

class Ec2PaTitle extends Component {

  state = {
    downloadStatus: 'none',
    url: '',
    downloadMessage: 'Click the "DOWNLOAD" button to generate a spreadsheet of the last 3 - 4 months of EC2 patch logs. Once the spreadsheet has been generated you will be given a signed URL that will allow the CSV file to be downloaded. This link will only be valid for one hour. Due to the cost associated with preparing this database please only use when necessary.'
  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="Ec2PaTitlePage">
        <h1>EC2 Patch Errors</h1>
        {this.state.downloadStatus === 'none' && <button onClick={this.tableDownload}>DOWNLOAD RECENT DATA</button>}
        <p>{this.state.downloadMessage}</p>
        {this.state.downloadStatus === 'pending' && <p className="AnimatedElipses">Please wait</p>}
        {this.state.url && <p><a href={this.state.url} target="_blank">Click here to download</a></p>}
      </div>
    );

  };

    tableDownload = () => {

      let totalTime = 0;

      if (this.state.downloadStatus === 'none' || this.state.downloadStatus === 'error') {
        this.setState({downloadStatus: 'pending', downloadMessage: 'The EC2 Patch Log CSV is currently being prepared. This can take up to 15 minutes. Do not navigate away from or refresh the page.'});
        API.get('WBU', '/ec2commands', {
          queryStringParameters: {
            action: 'download'
          }
        })
        .then(res => {

          const recursiveUrlCheck = () => {
            return new Promise(resolve => {
              setTimeout(() => resolve(), 20000);
            })
            .then(res => {
              return API.get('WBU', '/ec2commands', {
                queryStringParameters: {
                  action: 'getdownload'
                }
              });
            })
            .then(res => {
              totalTime += 20;
              if (res.status === 'ready') return {url: res.url, downloadStatus: 'finished', downloadMessage: 'Your report has been generated. Click the link below to download. Please note this link will only be valid for one hour.'};
              else if (totalTime > 959) return {downloadStatus: 'timedOut', downloadMessage: 'The report generator has timed out. Please contact the Infrastructure team.'};
              else {
                return recursiveUrlCheck();
              }
            });
          };

          return recursiveUrlCheck();

        })
        .then(res => {
          this.setState(res);
        })
        .catch(err => {
          console.log(err);
          this.setState({downloadStatus: 'error', downloadMessage: 'An error has occurred. Please contact the Infrastructure team.'});
        });
      }
    }

};

export default Ec2PaTitle;


// WEBPACK FOOTER //
// ./src/components/content/ec2PatchErrors/ec2PaTitle/ec2PaTitle.js